// Reviewed
import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ProductListSliderURL } from "../../APIServices/ProductListRequest";
import TopBannerSliderPlaceholder from "./TopBannerSliderPlaceholder";
import axios from "axios";
import { Link } from "react-router-dom";

class TopBannerSlider extends Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
      Next: function () {
        Slider.slickNext();
      },
      DataList: null,
    };
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  componentDidMount() {
    this.SelectProductList();
  }

  SelectProductList = () => {
    axios.get(ProductListSliderURL()).then((res) => {
      this.setState({ DataList: res.data });
    });
  };

  render() {
    let settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      vertical: true,
      verticalSwiping: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    let ProductList = this.state.DataList;
    let ProductListView = <TopBannerSliderPlaceholder />;

    if (ProductList !== null) {
      if (ProductList.length < 3) {
        let i = 0;
        while (ProductList.length < 3) {
          ProductList.push(this.state.DataList[i]);
          i++;
        }
      }
    }

    if (ProductList !== null) {
      ProductListView = ProductList.map((list, i) => {
        return (
          <Link key={i} to={"/ProductDetails/" + list["product_code"]}>
            <div className="TopBannerItem position-relative">
              <img className="d-none d-sm-block" src={list["image"]} alt=""/>
              <img className="d-block d-sm-none" src={list["mobile_slider"]} alt=""/>
            </div>
          </Link>
        );
      });
    }

    return (
      <div className="home-banner">
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {ProductListView}
        </Slider>
      </div>
    );
  }
}
export default TopBannerSlider;
